export const HOME = "/";
export const GUIDE = "/guide";
export const DEVELOPER = "/developer";
export const DEVELOPER_WELCOME = "/developer/new";
export const DEVELOPER_REGISTER = "/developer/register";
export const DEVELOPER_PROJECTS = "/developer/projects";
export const DEVELOPER_PROJECT_REGISTER = "/developer/projects/new";
export const DEVELOPER_PROJECT_JOIN = "/developer/projects/join";
export const DEVELOPER_PROJECT_DETAIL = "/developer/projects";
export const APP_CONSOLE = "/app_console";
